import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { HttpErrorResponse } from "@angular/common/http";
import { Observable, Subject } from 'rxjs';

import { UserTLR } from '../../../humain/user/entities/user-tlr.entity'
import { PlanPreventionEntity } from '../../entities/plan-prevention.entity';
import { SubjectRelay } from '../../../../shared/commands/subject-relay.class';

import { PlanPreventionService } from '../../services/plan-prevention.service';
import { UserService } from '../../../humain/user/services/user.service';

@Component({
	selector: 'pdp-validation-refresh',
	templateUrl: 'pdp-validation-refresh.html',
	styleUrls: ['pdp-validation-refresh.css'],
})
export class PdpValidationRefreshComponent {
	
	@Input() id = 'pdpValidationRefreshDialog';
	
	// Liaison de l'observable servant a commander l'affichage du composant
	private refreshValidationCommandsSubject = new SubjectRelay<PlanPreventionEntity>();
	@Input() set refreshValidationCommands(obs: Observable<PlanPreventionEntity> | undefined) {
		this.refreshValidationCommandsSubject.registerSource(obs);
	}
	
	// Gestion globale de la fenetre
	displaySubject = new Subject<boolean>();
	planPrevention!: PlanPreventionEntity;
	link: string = '';

	waitingForServer: boolean = false;
	user!: UserTLR;
	today: Date = new Date();

	constructor(
		@Inject(PlanPreventionService) private planPreventionService: PlanPreventionService,
		@Inject(UserService) userService: UserService,
	) {
		// Lors de la reception d'une demande de signature de pdp
		this.refreshValidationCommandsSubject.subscribe(
			(data) => {
				// faire les affectations puis afficher la fenetre
				this.waitingForServer = false;
				this.planPrevention = data;
				this.link = data.lien;
				this.displaySubject.next(true);
			}
		);
		
		let user$ = userService.getCurrentUserTLR();
		user$.subscribe(
		  (user: UserTLR) => this.user = user
		);

	}

	// Evenements de changement sur le pdp
	@Output() pdpChanged = new EventEmitter<number>();

	private cleanAndClose() {
		this.displaySubject.next(false);
		this.pdpChanged.emit(this.planPrevention?.id);
	}

	onRevaliderRequested() {
		this.waitingForServer = true;

		this.planPreventionService.revalider(this.planPrevention.id).subscribe({
		  next: () => {
		    this.waitingForServer = false;
		    this.cleanAndClose();
		  },
		  error: (error: HttpErrorResponse) => {
		    console.error('Erreur lors de la revalidation du PDP', error);
		    this.waitingForServer = false;
		  }
		});
	}
	
	onInvaliderRequested() {
		this.waitingForServer = true;

		this.planPreventionService.invalider(this.planPrevention.id).subscribe({
		  next: () => {
		    this.waitingForServer = false;
		    this.cleanAndClose();
		  },
		  error: (error: HttpErrorResponse) => {
		    console.error('Erreur lors de l\'invalidation du PDP', error);
		    this.waitingForServer = false;
		  }
		});
	}
}